'use strict';

var baseConvertIntArray = require('base-convert-int-array');

var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

function encode(buffer, fixedLength) {
  return baseConvertIntArray(buffer, {
    from: 256,
    to: 62,
    fixedLength: fixedLength
  }).map(function (value) {
    return CHARS[value];
  }).join('');
}

exports.encode = encode;

function decode(string, fixedLength) {
  // Optimization from https://github.com/andrew/base62.js/pull/31.
  var input = Array.from(string, function (_char) {
    var charCode = _char.charCodeAt(0);

    if (charCode < 58) return charCode - 48;
    if (charCode < 91) return charCode - 55;
    return charCode - 61;
  });
  return Buffer.from(baseConvertIntArray(input, {
    from: 62,
    to: 256,
    fixedLength: fixedLength
  }));
}

exports.decode = decode;